import { jsx } from '@emotion/react';
import { Alert, Link } from '@zapier/design-system';
import { useUniversalNavContext } from '../../../../universal-nav/hooks';
const calcDaysUntilRenewal = (renewalDate) => {
    const endDate = new Date(renewalDate);
    const now = new Date();
    const msBetweenDays = endDate.getTime() - now.getTime();
    return Math.round(msBetweenDays / (24 * 60 * 60 * 1000));
};
export const shouldRender = (data) => {
    const { currentAccount, currentUser } = data;
    if ((currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.subscriptionRenewalDate) === null)
        return false;
    return (currentUser.isLoggedIn &&
        !currentAccount.paysManually &&
        currentAccount.plan.interval === 'year' &&
        (currentAccount.currentUserRole === 'owner' ||
            currentAccount.currentUserRole === 'super_admin') &&
        !currentAccount.isEnterpriseAccount &&
        calcDaysUntilRenewal(currentAccount.subscriptionRenewalDate) <= 30);
};
export const Component = function AnnualPlanRenewalNotice(props) {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const currentAccount = props.data.currentAccount;
    if ((currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.subscriptionRenewalDate) == null)
        return null;
    const renewDays = calcDaysUntilRenewal(currentAccount.subscriptionRenewalDate);
    const billingSettingsURL = getFullyQualifiedURL(encodeURI(`/app/settings/${currentAccount.id}/billing`));
    const pluralize = renewDays > 1;
    const title = (jsx("span", { "data-zds": true },
        "Heads up, your plan renews in ",
        renewDays,
        " ",
        pluralize ? 'days' : 'day',
        '. ',
        jsx(Link, { href: billingSettingsURL, target: "_blank" }, "Review your plan details")));
    return jsx(Alert, { variant: "banner", title: title, status: "info" });
};
//# sourceMappingURL=AnnualPlanRenewalNotice.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
